import {useQuery, UseQueryResult} from '@tanstack/react-query';
import {QUERY_KEYS} from "./queryKeys";
import Api from "../api/Api";
import {IResult, IUserProfile} from "../types/api";

export default function useGetUserProfile(): UseQueryResult<void | IResult<IUserProfile>, Error> {
  return useQuery({
    queryKey: [QUERY_KEYS.user.getUserProfile],
    queryFn: async (): Promise<void | IResult<IUserProfile>> => {
      try {
        return await Api.currentUser.getUserProfile();
      } catch (error) {
        console.error('Error fetching user profile:', error);
        throw error;
      }
    }
  });
}
